import { Events } from '../event';
import { ObjectExt } from '../object';
import { Disposable } from './disposable';
export class Basecoat extends Events {
}
(function (Basecoat) {
    Basecoat.dispose = Disposable.dispose;
})(Basecoat || (Basecoat = {}));
ObjectExt.applyMixins(Basecoat, Disposable);
//# sourceMappingURL=basecoat.js.map